import * as React from 'react';
import * as Data from '../Data';
import * as Dati from '../Dati';
import * as Glob from '../Globale';
import { BaseComponent } from './BaseComponent';
import { InputData, Trad, BottoneAPI, Tipo, CampoMultiSelezione } from '.';

interface IAddendumActionsFormData extends Dati.CAppendiceDati {
    AppendiceGroup?: object[];
}

interface IAddendumActions {
    FormData: IAddendumActionsFormData[];
    Disabled: boolean;
    OnCreateAddendum: (dati: Dati.CRisAPI) => any,
    Policy: string,
    PolicyId: number,
}

interface IAddendumActionsState {
    DataEffetto: Date;
    DataScadenza: Date;
    ID_TipoAppendice: string;
    Nota: string;
}

export class AddendumActions extends BaseComponent<IAddendumActions, IAddendumActionsState> {
    private _AddendumType: Dati.TDictTipo = {};

    public constructor(props: any) {
        super(props);
        this.state = {
            DataEffetto: new Date(Date.now()),
            DataScadenza: new Date(Date.now()),
            ID_TipoAppendice: '',
            Nota: ''
        };

        this._AddendumType["AT-Proroga"] = new Dati.CTipo("AT-Proroga", "Extension Endorsement");
        this._AddendumType["AT-Svincolo"] = new Dati.CTipo("AT-Svincolo", "Release Endorsement");

        this.OnChange = this.OnChange.bind(this);
        this.OnClickCreateAddendumRequest = this.OnClickCreateAddendumRequest.bind(this);
    }

    private RenderFormField(field: any): React.ReactNode {
        let fieldNode:any = null;
        switch (field.ID_TipoCampo) {
            case 3: //Date
                fieldNode = <input className="form-control kt-input" type="text" value={field.ValoreAppendice && Data.DataValoreStringa(field.ValoreAppendice)} name={field.CampoAppendice} readOnly />;
                break;
            case 5: //Checkbox
                fieldNode = (
                    <div className="col-lg-12">
                        <label className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">{Trad.Trad(field.Etichetta)}
                            <input name={field.CampoAppendice} id={field.CampoAppendice} type="checkbox" checked={!!field.ValoreAppendice} readOnly />
                            <span />
                        </label>
                    </div>
                );
                break;
            case 12: //MultiSelezione
                fieldNode = (
                    <CampoMultiSelezione
                        Valori={field.AppendiceGroup && field.AppendiceGroup[0]}
                        Id={field.CampoAppendice}
                        Name={field.CampoAppendice}
                        Grafica="CheckBox"
                        OnChange={() =>{}}
                        BloccoAltezza={false}
                    />
                );
                break;
            default:
                fieldNode = <input className="form-control kt-input" type="text" value={field.ValoreAppendice} name={field.CampoAppendice} readOnly />;
                break;
        }
        return (
            <React.Fragment>
                {field.Etichetta && !(field.ID_TipoCampo == 5) && <label className="form-control-label">{Trad.Trad(field.Etichetta)}</label>}
                {fieldNode}
            </React.Fragment>
        )
    }

    private OnClickCreateAddendumRequest(sender: BottoneAPI): any {
        const MainData: Dati.CAppendiceTestata = new Dati.CAppendiceTestata();
        const FormData = this.props.FormData.map(item => {
            if (item.ID_TipoCampo === 3) {
                item.ValoreAppendice = Glob.DataValoreStringa(item.ValoreAppendice);
            }
            delete item.AppendiceGroup;
            return item;
        });

        return {
            Testata: {
                ...MainData,
                ...this.state,
                DataScadenza: this.state.DataScadenza || undefined,
                ID_Polizza: this.props.PolicyId,
                Polizza: this.props.Policy
            },
            Dati: FormData
        };
    }

    private OnCreateAddendumError(sender: BottoneAPI, error: Error) {
        Glob.InfoModaleError(Trad.Trad("ADDENDUM ERROR"), error.message);
    }

    public render() {
        const hadAddendumData = this.props.FormData.length !== 0;

        return (
            <React.Fragment>
                <div className="modal fade" id="AddendumModal" role="dialog" aria-labelledby="AddendumModal" key={0}>
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header alert-info">
                                <span className="kt-portlet__head-icon"><i className="fa fa-sticky-note" /></span>
                                <h3 className="modal-title">{Trad.Trad('Addendum')}</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group kt-form login-form__group row">
                                    <div className="col-lg-8 kt-form login-form__group-sub">
                                        <label className="form-control-label">{Trad.Trad("Addendum type")}</label>
                                        <Tipo
                                            Campo="ID_TipoAppendice"
                                            ID_ChiaveString={this.state.ID_TipoAppendice}
                                            Dati={hadAddendumData ? undefined : this._AddendumType}
                                            URL={hadAddendumData ? "/api/Tipi/ListaTipi?ID_TipoContesto=AppendiceTipo" : undefined}
                                            OnAggiorna={this.OnChange}
                                            TradValori={!hadAddendumData}
                                            Ordinato
                                            Richiesto
                                        />
                                    </div>
                                </div>
                                <div className="form-group kt-form login-form__group row">
                                    <div className={Glob.DimensioneCSS(6)}>
                                        <InputData
                                            ValoreInArrivo
                                            Name="DataEffetto"
                                            Id="DataEffetto"
                                            Valore={this.state.DataEffetto}
                                            OnChange={this.OnChange}
                                            Etichetta="DataEffetto"
                                        />
                                    </div>
                                    <div className={Glob.DimensioneCSS(6)}>
                                        <InputData
                                            ValoreInArrivo
                                            Name="DataScadenza"
                                            Id="DataScadenza"
                                            Valore={this.state.DataScadenza}
                                            OnChange={this.OnChange}
                                            Etichetta="DataScadenza"
                                            IsClearable
                                        />
                                    </div>
                                </div> 
                                <div className="form-group kt-form login-form__group row" key="Nota">
                                    <div className="col-lg-12">
                                        <label>{Trad.Trad("Note")}</label>
                                        <div className="kt-input-icon kt-input-icon--right">
                                            <textarea
                                                className="form-control"
                                                value={this.state.Nota}
                                                name="Nota"
                                                id="Nota"
                                                onChange={this.OnChange}
                                                rows={4}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {this.props.FormData.map((item) => (
                                    <div className="form-group kt-form login-form__group row">
                                        <div className="col-lg-12">
                                            {(item.AppendiceGroup && item.AppendiceGroup.length > 0 && item.ID_TipoCampo != 12)
                                                ? item.AppendiceGroup.map((groupItem) => this.RenderFormField(groupItem))
                                                : this.RenderFormField(item)
                                            }
                                        </div>
                                    </div>
                                ))}          
                            </div>
                            <div className="modal-footer">
                                <BottoneAPI
                                    Visibile
                                    Attivo
                                    Default={false}
                                    Testo={Trad.Trad("Richiedi")}
                                    URL="/api/Appendice"
                                    Metodo="POST"
                                    OnInvio={this.OnClickCreateAddendumRequest}
                                    OnClick={(s, d) => this.props.OnCreateAddendum(d)}
                                    OnErrore={(s, e) => this.OnCreateAddendumError(s, e)}
                                    ClasseAttesa="btn btn-success kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                    ClasseAttivo="btn btn-success"
                                    DataDismiss="modal"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    key={1}
                    className={"btn btn-metal"}
                    type="button"
                    data-toggle="modal"
                    title={Trad.Trad('Addendum')}
                    data-target="#AddendumModal"
                    id="btnAddendumModal"
                    disabled={this.props.Disabled}
                >
                    <span>
                        <i className="fa fa-level-up-alt" />
                        <span> {Trad.Trad('Addendum')}</span>
                    </span>
                </button>
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AddendumActions.tsx